import { createFileRoute } from "@tanstack/react-router";
import { CodeBrowser } from "@/faults-app/components/code-browser";

export const Route = createFileRoute("/ac-codes")({
  head: () => ({
    meta: [
      { title: "رموز أعطال المكيفات Split AC" },
      {
        name: "description",
        content:
          "دليل عربي لرموز أعطال مكيفات السبليت حسب الشركة والموديل: معنى الكود، سبب المشكلة، خطوات التشخيص، القطع المشتبهة وطريقة المعالجة.",
      },
      { property: "og:title", content: "رموز أعطال المكيفات Split AC" },
      {
        property: "og:description",
        content: "ابحث عن كود المكيف حسب الشركة واحصل على سبب العطل وخطوات التشخيص والحل.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: AcCodes,
});

function AcCodes() {
  return (
    <CodeBrowser
      domain="ac"
      title="رموز أعطال المكيفات Split AC"
      subtitle="اختر الشركة ← الموديل ← رمز العطل"
      brandLabel="شركة المكيف"
      searchPlaceholder="مثال: E5 أو CH05 أو Gree"
    />
  );
}
